<template>
    <div id="reading-tracker-backdrop" class="reset-vertical"
        v-show="startReading"
        tabindex="1"
        @click="moveTo"
        @keydown.stop="keyHandler">
        <div class="close-button" @click.stop="close()">
            <span class="times"></span>
        </div>
        <div id="reading-tracker" class="b-light"
            :class="{
                'vertical': $store.state.is_horizontal == 0,
            }"
            @click.stop="">
            <div id="text-pane" v-html="$filters.ruby(body)"></div>
        </div>
    </div>
</template>

<style scoped lang="scss">
$text-length: 780px;
#reading-tracker-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    width: 100%;
    height: 100%;
    opacity: .95;
    outline: none;
    .close-button {
        position: absolute;
        top: 16px;
        right: 16px;
        cursor: pointer;
        .times {
            display: block;
            position: relative;
            width: 96px;
            height: 96px;
            &::before, &::after {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                width: 3px;
                height: 96px;
                background: #777;
            }
            &::before {
                transform: translate(-50%,-50%) rotate(45deg);
            }
            &::after {
                transform: translate(-50%,-50%) rotate(-45deg);
            }
        }
    }
    #reading-tracker {
        position: relative;
        width: 100%;
        height: 9rem;
        margin: calc(100dvh / 2 - 4.5rem) auto;
        overflow-y: hidden;
        -ms-overflow-style: none;
        scrollbar-width: none;
        &::-webkit-scrollbar {
            display: none;
        }
        padding-left: 2rem;
        padding-right: 2rem;
        #text-pane {
            font-size: 1.5rem;
            line-height: 3rem;
            max-width: $text-length;
            margin: 0 auto;
        }
        &.vertical {
            width: 9rem;
            height: 100%;
            height: calc(var(--vh, 1vh) * 100);
            margin: 0 auto;
            padding: 2rem 0;
            #text-pane {
                line-height: 3rem;
                max-height: $text-length;
                margin: auto 0;
            }
        }
    }
}
</style>

<script>
export default {
    props: {
        body: {
            default: ""
        },
        startReading: {
            default: false
        }
    },
    data() {
        return {
            pos: 0,
            moving: false,  // スクロール中
        }
    },
    methods: {
        startReadingTracker() {
            this.scrollTo();
            setTimeout(() => {
                $("#reading-tracker-backdrop").focus();
            }, 500);
        },
        // キー移動
        keyHandler(ev) {
            if (ev.key === "Escape") {
                this.close();
                return;
            }
            if (this.moving) {
                ev.returnValue = false;
                return;
            }
            this.moving = true;
            const orgpos = this.pos;
            if (ev.key === "ArrowDown" || ev.key === "ArrowLeft") {
                // 進む
                this.pos++;
            } else if (ev.key === "ArrowUp" || ev.key === "ArrowRight") {
                // 戻る
                this.pos--;
                if (this.pos < 0) this.pos = 0;
            }
            if (orgpos !== this.pos) {
                this.scrollTo();
                ev.returnValue = false;
            } else {
                this.moving = false;
            }
        },
        // クリック・タップ移動
        moveTo(ev) {
            if (this.moving) return;
            this.moving = true;
            const orgpos = this.pos;
            if (this.$store.state.is_horizontal) {
                const border = $("#reading-tracker-backdrop")[0].clientHeight / 2;
                if (border > ev.y) {
                    this.pos--;
                    if (this.pos < 0) this.pos = 0;
                } else {
                    this.pos++;
                }
            } else {
                const border = $("#reading-tracker-backdrop")[0].clientWidth / 2;
                if (border < ev.x) {
                    this.pos--;
                    if (this.pos < 0) this.pos = 0;
                } else {
                    this.pos++;
                }
            }
            if (orgpos !== this.pos) {
                this.scrollTo();
            } else {
                this.moving = false;
            }
        },
        scrollTo() {
            if (this.$store.state.is_horizontal) {
                const scrollTop = this.pos * 48;
                if ($("#reading-tracker")[0].scrollHeight && scrollTop > ($("#reading-tracker")[0].scrollHeight - 48)) {
                    this.pos--;
                    this.close(true);
                    return;
                }
                $("#reading-tracker").animate({scrollTop: scrollTop}, {duration: 200});
            } else {
                const scrollLeft = this.pos * 48 * -1;
                if ($("#reading-tracker")[0].scrollWidth && ($("#reading-tracker")[0].scrollWidth - 48 + scrollLeft) < 0) {
                    this.pos--;
                    this.close(true);
                    return;
                }
                $("#reading-tracker").animate({scrollLeft: scrollLeft}, {duration: 200});
            }
            setTimeout(() => {this.moving = false}, 100);
        },
        close(scrollToEnd = false) {
            if (scrollToEnd) {
                if (this.$store.state.is_horizontal) {
                    let elm = document.documentElement;
                    let bottom = elm.scrollHeight - elm.clientHeight;
                    window.scrollTo({
                        left: 0,
                        top: bottom,
                        behavior: "smooth"
                    });
                } else {
                    let left = ($("#section_container")[0].scrollWidth - $("#section_container")[0].clientWidth) * -1;
                    $("#section_container")[0].scrollTo({
                        left: left,
                        top: 0,
                        behavior: "smooth"
                    });
                }
            }
            this.$emit("close");
        },
        getSize() {
            const vh = (window.innerHeight) * 0.01;
            if (document.querySelector("#reading-tracker.vertical")) {
                document.querySelector("#reading-tracker.vertical").style.setProperty('--vh', `${vh}px`);
            } else {
                setTimeout(this.getSize, 300);
            }
        }
    },
    watch: {
        startReading(n, o) {
            if (n) {
                this.startReadingTracker();
            }
        },
        $route(to, from) {
            this.pos = 0;
        }
    },
    mounted() {
        $(window).on("resize", this.getSize);
        this.getSize();
    }
}
</script>